import styled, { css } from 'styled-components';

const ReviewContainer = styled.div`
  border-radius: 4px;
  width: 100%;

  > p,
  > span {
    font-weight: normal;
    line-height: 1.4;
  }
`;

interface isVerifiedPurchaserProp {
  isVerifiedPurchaser?: boolean;
}

const SignatureContainer = styled.div<isVerifiedPurchaserProp>`
  margin: 10px 0 16px;
  display: flex;
  flex-direction: column;
  font-size: ${({ theme }) => theme.fontSize.xs};

  > div {
    position: relative;
  }

  & small {
    margin-right: 10px;
  }

  ${({ isVerifiedPurchaser }) =>
    !isVerifiedPurchaser &&
    css`
      margin-bottom: 0px;
    `}
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px 16px 0 16px;
  width: 100%;
`;

const Title = styled.h3`
  font-family: Arial;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 18px;
  display: flex;
  align-items: flex-end;
  color: #666666;
  padding-bottom: 4px;
`;

const HrStyled = styled.hr`
  border: none;
  border-bottom: 1px solid #e8e8e8;
  width: 100%;
`;

export default ReviewContainer;
export { ReviewContainer, SignatureContainer, Wrapper, Title, HrStyled };
